// SPDX-FileCopyrightText: 2026 Ebiose AI
// SPDX-License-Identifier: LicenseRef-Ebiose-Proprietary
// All rights reserved. Confidential — unauthorized distribution prohibited.

import { Navigate, Outlet, useLocation } from "react-router-dom"
import { FullPageSpinnerWithText } from "@/components/ui/spinner"
import { SessionUnavailable } from "@/components/SessionUnavailable"
import { useSession, useSessionExpiry } from "@/queries/session"
import { safeReturnTo } from "@/lib/return-to"

// Routes declared outside this layout route are the public ones — the
// guard holds no path list of its own.
export const ProtectedRoute = () => {
  const { status, reprobe } = useSession()
  const location = useLocation()
  useSessionExpiry()

  if (status === "pending") {
    return <FullPageSpinnerWithText text="Authenticating..." />
  }

  if (status === "indeterminate") {
    return <SessionUnavailable onRetry={reprobe} />
  }

  if (status === "anonymous") {
    const returnTo = safeReturnTo(
      `${location.pathname}${location.search}${location.hash}`,
    )
    return <Navigate to="/login" replace state={{ returnTo }} />
  }

  return <Outlet />
}
